var exports = {
  "az": "Box__eKDAUk",
  "wy": "Box_1__FM0dkd",
  "pv": "Box_2__L1B3c6",
  "m4": "Octicon__CTDdvq",
  "EY": "Text__g4I3T-",
  "UE": "Text_1__6jpSZZ",
  "w9": "Box_3__dQpLSz",
};

module.exports = exports;
